var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.996,
    height: 38.972,
    viewBox: "0 0 38.996 38.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(-52.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M292.662,167.49H278.579c-.037,0-.073-.011-.11-.011h0a5.545,5.545,0,0,0-5.53,5.53v13.969a5.545,5.545,0,0,0,5.53,5.528h.224a5.318,5.318,0,0,0,5.3-5.3v-8.652h8.44a5.545,5.545,0,0,0,5.53-5.529v-.226A5.32,5.32,0,0,0,292.662,167.49Z",
    transform: "translate(-206.042 -153.534)",
    fill: "#54c1bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M283.836,158.892h-.226a5.319,5.319,0,0,0-5.3,5.3v8.652h-8.44a5.545,5.545,0,0,0-5.53,5.53v.226a5.32,5.32,0,0,0,5.3,5.3h14.081c.039,0,.075.011.114.011a5.545,5.545,0,0,0,5.528-5.53V164.422A5.545,5.545,0,0,0,283.836,158.892Z",
    transform: "translate(-211.41 -158.892)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M278.469,167.479a5.545,5.545,0,0,0-5.53,5.53v5.541h5.416c.039,0,.075.011.114.011a5.545,5.545,0,0,0,5.528-5.53V167.49h-5.417C278.542,167.49,278.506,167.479,278.469,167.479Z",
    transform: "translate(-206.042 -153.534)",
    fill: "#04496b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3fe7f132.svg";
export { ForwardRef as ReactComponent };